import { render } from "./IframeLoader.vue?vue&type=template&id=cd19ae1a"
import script from "./IframeLoader.vue?vue&type=script&lang=js"
export * from "./IframeLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__